'use client'

import { Download } from 'lucide-react'

/**
 * The template download. A plain <a download> so it works with JavaScript off;
 * the click handler only reports the event.
 *
 * Analytics: there is no shared event helper for GA4 yet, so this calls
 * `window.gtag` directly, guarded for its absence (it only exists on the public
 * marketing paths, and only once consent allows). The `data-ga-*` attributes
 * are there for the GA agent's helper to hook instead when it lands.
 */
export function DownloadLink({
  href,
  slug,
  name,
  fileLabel,
  className,
}: {
  href: string
  slug: string
  name: string
  /** e.g. "Word document, 12 KB" — part of the accessible name. */
  fileLabel: string
  className?: string
}) {
  return (
    <a
      href={href}
      download
      className={className}
      data-ga-event='view_report_sample'
      data-template-slug={slug}
      data-file-type='docx'
      onClick={() => {
        try {
          window.gtag?.('event', 'view_report_sample', {
            template_slug: slug,
            file_type: 'docx',
            link_url: href,
          })
        } catch {
          // Analytics must never block the download.
        }
      }}
    >
      <Download aria-hidden className='mr-2 h-4 w-4' />
      Download the {name.toLowerCase()} ({fileLabel})
    </a>
  )
}
